import { render, staticRenderFns } from "@/components/Layout/Reportes/Reportes_gestiones/Reportes_gestiones.html?vue&type=template&id=4b835287&scoped=true&"
import script from "@/components/Layout/Reportes/Reportes_gestiones/Reportes_gestiones.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Reportes/Reportes_gestiones/Reportes_gestiones.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Reportes/Reportes_gestiones/Reportes_gestiones.css?vue&type=style&index=0&id=4b835287&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b835287",
  null
  
)

export default component.exports